import type { DanceSeoHead } from "../danceSeoTypes.js";

// ko translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "AI 댄스 영상 생성기 | 노래로 만들기 · 무료로 시작",
    description:
      "노래를 완성된 AI 댄스 영상으로. Solmi가 섹션별 안무를 짜고 스토리보드를 만든 뒤 댄스 샷과 립싱크 샷을 렌더링합니다. 무료로 시작.",
    h1: "AI 댄스 영상 생성기 — 어떤 노래든 댄스 영상으로",
  },
  photo: {
    title: "사진 춤추게 하기: 사진으로 AI 댄스 생성 | Solmi",
    description:
      "사진을 춤추게 하는 AI. 전신 사진을 올리고, 동작을 고르거나 내 클립을 올리고, 노래를 넣으면 Solmi가 비트에 맞춥니다. 무료로 시작.",
    h1: "사진 춤추게 하기 — 사진으로 만드는 AI 댄스",
  },
  inbound:
    "퍼포머가 춤추게 하고 싶으신가요? [AI 댄스 영상 생성기](/ai-dance-video-generator)가 노래의 모든 섹션에 안무를 짜고 전곡 댄스 영상을 렌더링합니다.",
};

export default head;
